/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loginsubmitting1Inputs */

const en_loginsubmitting1 = /** @type {(inputs: Loginsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

const pt_loginsubmitting1 = /** @type {(inputs: Loginsubmitting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A enviar…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Loginsubmitting1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const loginsubmitting1 = /** @type {((inputs?: Loginsubmitting1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loginsubmitting1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loginsubmitting1(inputs)
	return pt_loginsubmitting1(inputs)
});
export { loginsubmitting1 as "loginSubmitting" }